<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        title="Periode kiezen"
        :small="true"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <dean-form-row id="startDate" label="startdatum" type="date" v-model="dates.startDate" :warning="$v.dates.startDate.$error" @focus="$v.dates.startDate.$touch()" :required-field="true"></dean-form-row>
      <dean-form-row id="endDate" label="einddatum" type="date" v-model="dates.endDate" :warning="$v.dates.endDate.$error" @focus="$v.dates.endDate.$touch()" :required-field="true"></dean-form-row>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="send()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanDialogButtonGroup,
      deanFormRow,
    },
    mixins: [validationMixin],
  })

  export default class PeriodDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public dates: any = {
      startDate: null,
      endDate: null,
    };
    public url: string = '';
    public urlParams: any = {};

    // COMPUTED
    @Validations()
    get validations() {
      return {
        dates: {
          startDate: {required},
          endDate: {required},
        },
      };
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public send() {
      this.$v.$touch();

      interface PeriodSaveRequestMapper {
        id: string;
        startDate: string;
        endDate: string;
        newStartDate: string;
        newEndDate: string;
      }

      const periodSaveRequestMapper: PeriodSaveRequestMapper = {
        id: this.payloadData.contextId,
        startDate: this.payloadData.oldStartDate,
        endDate: this.payloadData.oldEndDate,
        newStartDate: this.dates.startDate,
        newEndDate: this.dates.endDate,
      };
      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);

        this.$store.dispatch('processRecurringCommissionPlanPeriod', periodSaveRequestMapper)
          .then(
            (response: any) => {
              this.urlParams.contextId = response.data.data.id;
              deanDialogBus.$emit('periodSelected');
              this.routeAfterSend();
              this.close();
            },
            (error: any) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            },
          )
          .finally(() => {
            this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public created() {
      this.$emit('setLoad', true);

      interface PeriodInfoRequestMapper {
        id: string;
        startDate: string;
        endDate: string;
      }

      const periodInfoRequestMapper: PeriodInfoRequestMapper = {
        id: this.payloadData.contextId,
        startDate: this.payloadData.oldStartDate,
        endDate: this.payloadData.oldEndDate,
      };

      this.$store.dispatch('requestRecurringCommissionPlanPeriod', periodInfoRequestMapper)
      .then(
        (response: any) => {
          this.dates.startDate = response.data.startDate;
          this.dates.endDate = response.data.endDate;
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
        },
      )
      .finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }

    private routeAfterSend() { // TODO switch
      if (this.urlParams.context === 'priceplan') {
        if (this.urlParams.view === 'entry') {
          this.$router.push({name: 'standingData.pricePlan.entries.add', params: this.dates});
        } else {
          this.$router.push({name: 'standingData.pricePlan.entries.filter', params: this.dates});
        }
      } else {
        this.$router.push({name: 'standingData.recurringCommissionPlans.matrix.filter', params: {
            planId: this.urlParams.contextId,
            startDate: this.dates.startDate,
            endDate: this.dates.endDate,
          }});
      }
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

</style>
